<template>
	<div>
    <div class="tab flex-js-ac">
      <p :class="currentIndex == index ? 'active': ''" v-for="(item, index) in tab" @click="changeTab(index)">{{item}}</p>
    </div>
    <div class="tab1" v-show="currentIndex == 0">
      <div class="spacing">
        <div class="title flex-js-ac">
          <p class="f16">账号基础数据</p>
          <div class="f15 option flex-ac">
            <span :class="{'red': baseinfoShow}" @click="getBaseDataFn(0)">近7日</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span :class="{'red': !baseinfoShow}" @click="getBaseDataFn(1)">近30日</span>
          </div>
        </div>
        <div class="flex-js-ac dataoverview">
          <div class="flex-1 f13">
            总阅读数
            <p class="f17">{{baseinfo.readnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/browse.png" />
          </div>
          <div class="flex-1 f13">
            发布帖子数
            <p class="f17">{{baseinfo.communitynum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/post.png" />
          </div>
        </div>
        <div style="width: auto;height: 2.12rem" id="baseinfo"></div>
      </div>
      <div class="spacing">
        <div class="title flex-js-ac">
          <p class="f16">帖子赞藏评数据</p>
          <div class="f15 option flex-ac">
            <span :class="{'red': likeandcolinfoShow}" @click="getLikeAndColFn(0)">近7日</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span :class="{'red': !likeandcolinfoShow}" @click="getLikeAndColFn(1)">近30日</span>
          </div>
        </div>
        <div class="flex-js-ac dataoverview">
          <div class="flex-1 f13">
            点赞数
            <p class="f17">{{likeandcolinfo.likenum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/zan.png" />
          </div>
          <div class="flex-1 f13">
            评论数
            <p class="f17">{{likeandcolinfo.commentnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/commentdata.png" />
          </div>
          <div class="flex-1 f13">
            收藏数
            <p class="f17">{{likeandcolinfo.colnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/collect.png" />
          </div>
        </div>
        <div style="width: auto;height: 2.12rem" id="likeandcolinfo"></div>
      </div>
      <div class="spacing">
        <div class="title flex-js-ac">
          <p class="f16">总互动量（赞藏评合计）</p>
          <div class="f15 option flex-ac">
            <span :class="{'red': interactinfoShow}" @click="getInteractFn(0)">近7日</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span :class="{'red': !interactinfoShow}" @click="getInteractFn(1)">近30日</span>
          </div>
        </div>
        <div class="flex-js-ac dataoverview">
          <div class="f13" style="min-width: 1.05rem">
            总互动数
            <p class="f17">{{interactinfo.interacnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/interaction.png" />
          </div>
        </div>
        <div style="width: auto;height: 2.12rem" id="interactinfo"></div>
      </div>
    </div>
    <div class="tab2" v-show="currentIndex == 1">
      <p class="f13 color-FC0324 comment">*仅展示最近发布的7条帖子数据</p>
      <div class="spacing" v-for="item of postlist">
        <div class="postdata flex">
          <img v-lazy="item.img_path" alt="">
          <div class="postcontent">
            <p class="f14 over-ell-4">{{item.content}}</p>
            <span class="f13">发布时间：{{item.time}}</span>
          </div>
        </div>
        <div class="flex-js-ac dataoverview postdataoverview flex-w">
          <div class="f13">
            浏览数
            <p class="f17">{{item.readnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/browse.png" />
          </div>
          <div class="f13">
            点赞数
            <p class="f17">{{item.likenum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/zan.png" />
          </div>
          <div class="f13">
            收藏数
            <p class="f17">{{item.colnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/collect.png" />
          </div>
          <div class="f13">
            评论数
            <p class="f17">{{item.commentnum}}</p>
            <van-icon class="icon" size="0.14rem" name="/static/images/community/commentdata.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="tab3" v-show="currentIndex == 2">
      <div class="spacing">
        <div class="title flex-js-ac">
          <p class="f16">粉丝数据</p>
          <div class="f15 option flex-ac">
            <span :class="{'red': fansinfoShow}" @click="getFansFn(0)">近7日</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span :class="{'red': !fansinfoShow}" @click="getFansFn(1)">近30日</span>
          </div>
        </div>
        <div class="flex-js-ac dataoverview">
          <div class="flex-1 f13">
            新增粉丝
            <p class="f17">{{fansinfo.addfansnum}}</p>
          </div>
          <div class="flex-1 f13">
            流失粉丝
            <p class="f17">{{fansinfo.offfansnum}}</p>
          </div>
          <div class="flex-1 f13">
            总粉丝
            <p class="f17">{{fansinfo.totalfansnum}}</p>
          </div>
        </div>
        <div style="width: auto;height: 2.12rem" id="fansinfo"></div>
      </div>
      <div class="spacing">
        <div class="title flex-js-ac">
          <p class="f16">忠实粉丝</p>
          <div class="f15 option flex-ac">
            <span :class="{'red': loyalfansinfoShow}" @click="getLoyalFansFn(0)">近7日</span>&nbsp;&nbsp;|&nbsp;&nbsp;<span :class="{'red': !loyalfansinfoShow}" @click="getLoyalFansFn(1)">近30日</span>
          </div>
        </div>
        <div class="flex-ac dataoverview fans" v-if="loyalfansinfo.length">
          <div class="f13" v-for="item of loyalfansinfo">
            <img :src="item.head" @error="function(event) {let img = event.srcElement;img.src = errorHeadImg; img.onerror = null;}">
            <p class="f15 over-ell-1">{{item.name}}</p>
            <span class="f13">浏览{{item.readnum}}次</span>
          </div>
        </div>
        <div class="nodata" v-else>
          <img src="/static/images/community/nodata.png">
          <p class="f15">暂无数据</p>
        </div>
      </div>
      <div class="spacing">
        <div class="title flex-js-ac">
          <p class="f16">粉丝画像</p>
        </div>
        <div class="gender">
          <p class="f16">性别分布</p>
          <div class="flex proportionexample">
            <div :style="{'width': sexinfo.femaleratio}"></div>
            <div :style="{'width': sexinfo.malenratio}"></div>
            <div :style="{'width': sexinfo.unknownratio}"></div>
          </div>
          <div class="proportion flex-ac">
            <div class="f11 flex-ac">女性{{sexinfo.femaleratio}}</div>
            <div class="f11 flex-ac">男性{{sexinfo.malenratio}}</div>
            <div class="f11 flex-ac">未知{{sexinfo.unknownratio}}</div>
          </div>
          <p class="f16">年龄分布</p>
          <div style="width: auto;height: 2.12rem" id="ageinfo"></div>
        </div>
      </div>
    </div>
    <div v-if="empty && currentIndex == 1" class="emptybox" :style="{'height': emptyHeight/100 + 'rem', 'padding': '0.1rem 0.11rem'}">
      <empty v-if="empty" :path="'noData'"></empty>
    </div>
  </div>
</template>

<script>
import empty from '../emptypage/empty'
import {datacenterpath} from '../../assets/common/js/config'
import * as echarts from 'echarts';
export default {
  name: "dataCenter",
  components: {
    empty
  },
  data () {
    return {
      currentIndex: 0,
      tab: ['账号概览', '笔记分析', '粉丝数据'],
      empty: false,
      emptyHeight: 0,
      postlist: [], // 笔记分析数据
      baseinfo: {}, // 账号概览-账号基础数据
      baseinfoShow: true,
      likeandcolinfo: {}, // 账号概览-帖子赞藏评数据
      likeandcolinfoShow: true,
      interactinfo: {}, // 账号概览-总互动数
      interactinfoShow: true,
      fansinfo: {}, // 粉丝数据-粉丝基础数据
      fansinfoShow: true,
      loyalfansinitinfo: {}, // 粉丝数据-忠实粉丝原始数据
      loyalfansinfo: [], // 粉丝数据-忠实粉丝
      loyalfansinfoShow: true,
      sexinfo: {}, // 粉丝数据-性别分布
      ageinfo: {} // 粉丝数据-年龄分布
    }
  },
  mounted: function () {
    this.emptyHeight = document.body.clientHeight - 76
    this.$nextTick(function () {
      this.getData()
    })
  },
  methods: {
    getData: function () {
      if (this.currentIndex == 0) {
        this.getBaseDataFn(0, 1)
        this.getLikeAndColFn(0, 1)
        this.getInteractFn(0, 1)
      } else if (this.currentIndex == 1) {
        let url = datacenterpath + 'Wxmall/Community/getNoteAnalysis'
        this.$customRequestAjax(url).then(res => {
          if (res.data.code == 200) {
            this.postlist = res.data.list
            if (this.postlist.length <= 0) {
              this.empty = true
            } else {
              this.empty = false
            }
          }
        }).catch(err => {
          this.empty = true
        })
      } else if (this.currentIndex == 2) {
        this.getFansFn(0, 1)
        this.getLoyalFansFn(0)
      }
    },
    getBaseDataFn: function (type, isinit) {
      if (isinit != 1 && ((type == 0 && this.baseinfoShow) || (type == 1 && !this.baseinfoShow))) return
      if (type == 0) {
        this.baseinfoShow = true
      } else {
        this.baseinfoShow = false
      }
      let url = datacenterpath + 'Wxmall/Community/getBaseData?type=' + type
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.baseinfo = res.data.baseinfo
          echarts.init(document.getElementById('baseinfo')).setOption({
            color: ['#7D03FC', '#FC039E'],
            legend: {
              data: [{
                name: '总阅读数',
                icon: 'circle',
              },
                {
                  name: '发布帖子数',
                  icon: 'circle',
                }],
              orient: 'horizontal',
              top: 'bottom',
              selectedMode: false,
              align: 'left',
              itemGap: 24,//图例每项之间的间隔
              itemWidth: 7,
              itemHeight: 7,
              textStyle: {
                color: '#8B8788',
                fontSize: 11,
                padding: [0, 0, 0, 0]
              },
            },
            tooltip: {
              show: true,
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: '#FFCACA',
                  type: 'dash',
                },
                snap: false,
                label: {
                  formatter: '{value}'
                }
              },
            },
            grid: {
              top: '11%',
              left: '13%',
              right: '6%',
              bottom: '22%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: this.baseinfo.daykeylist,
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: '#969494',
                fontSize: 11
              },
              axisLine: {
                lineStyle: {
                  color: '#969494',
                },
              },
              boundaryGap: false,
            },
            yAxis: [
              {
                type: 'value',
                offset: '10',
                minInterval: 1,
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: '#969494'
                  },
                },
                axisTick: {
                  show: false,
                  inside: true,
                },
                axisLabel: {
                  fontSize: 11,
                  margin: 2,
                },
                splitLine: {
                  show:true,
                  lineStyle: {
                    color: '#f5f5f5',
                    height: 2
                  }
                },
              },
            ],
            dataZoom: [
              {
                type: 'inside',
                // start: this.state.timeMode == 2 ? 75 : 0,
                // end: this.state.timeMode == 2 ? 100 : 100,
                xAxisIndex: [0],
                filterMode: 'empty',
                handleSize: '10%'
              }
            ],
            series: [
              {
                name: '总阅读数',
                lineStyle: {
                  color: '#7D03FC',
                },
                data: this.baseinfo.readnumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#E1DBFF' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
              {
                name: '发布帖子数',
                lineStyle: {
                  color: '#FC039E',
                },
                data: this.baseinfo.communitynumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#FF97D6' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
            ],
          })
        }
      })
    },
    getLikeAndColFn: function (type, isinit) {
      if (isinit != 1 && ((type == 0 && this.likeandcolinfoShow) || (type == 1 && !this.likeandcolinfoShow))) return
      if (type == 0) {
        this.likeandcolinfoShow = true
      } else {
        this.likeandcolinfoShow = false
      }
      let url = 'Wxmall/Community/getPostsOperation?type=' + type
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.likeandcolinfo = res.data.likeandcolinfo
          echarts.init(document.getElementById('likeandcolinfo')).setOption({
            color: ['#FCC349', '#FC0324', '#0384FC'],
            legend: {
              data: [{
                name: '点赞数',
                icon: 'circle',
              },
                {
                  name: '评论数',
                  icon: 'circle',
                },
                {
                  name: '收藏数',
                  icon: 'circle',
                }],
              orient: 'horizontal',
              top: 'bottom',
              selectedMode: false,
              align: 'left',
              itemGap: 24,//图例每项之间的间隔
              itemWidth: 7,
              itemHeight: 7,
              textStyle: {
                color: '#8B8788',
                fontSize: 11,
                padding: [0, 0, 0, 0]
              },
            },
            tooltip: {
              show: true,
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: '#FFCACA',
                  type: 'dash',
                },
                snap: false,
                label: {
                  formatter: '{value}'
                }
              },
            },
            grid: {
              top: '11%',
              left: '13%',
              right: '6%',
              bottom: '22%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: this.likeandcolinfo.daykeylist,
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: '#969494',
                fontSize: 11
              },
              axisLine: {
                lineStyle: {
                  color: '#969494',
                },
              },
              boundaryGap: false,
            },
            yAxis: [
              {
                type: 'value',
                offset: '10',
                minInterval: 1,
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: '#969494'
                  },
                },
                axisTick: {
                  show: false,
                  inside: true,
                },
                axisLabel: {
                  fontSize: 11,
                  margin: 2,
                },
                splitLine: {
                  show:true,
                  lineStyle: {
                    color: '#f5f5f5',
                    height: 2
                  }
                },
              },
            ],
            dataZoom: [
              {
                type: 'inside',
                // start: this.state.timeMode == 2 ? 75 : 0,
                // end: this.state.timeMode == 2 ? 100 : 100,
                xAxisIndex: [0],
                filterMode: 'empty',
                handleSize: '10%'
              }
            ],
            series: [
              {
                name: '点赞数',
                lineStyle: {
                  color: '#FCC349',
                },
                data: this.likeandcolinfo.likenumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#FFF6E8' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
              {
                name: '评论数',
                lineStyle: {
                  color: '#FC0324',
                },
                data: this.likeandcolinfo.commentnumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#FFD1D0' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
              {
                name: '收藏数',
                lineStyle: {
                  color: '#0384FC',
                },
                data: this.likeandcolinfo.colnumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#B9D2F3' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
            ],
          })
        }
      })
    },
    getInteractFn: function (type, isinit) {
      if (isinit != 1 && ((type == 0 && this.interactinfoShow) || (type == 1 && !this.interactinfoShow))) return
      if (type == 0) {
        this.interactinfoShow = true
      } else {
        this.interactinfoShow = false
      }
      let url = 'Wxmall/Community/getPostsInteraction?type=' + type
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.interactinfo = res.data.interactinfo
          echarts.init(document.getElementById('interactinfo')).setOption({
            color: ['#FC6C03'],
            legend: {
              data: [{
                name: '总互动数',
                icon: 'circle',
              }],
              orient: 'horizontal',
              top: 'bottom',
              selectedMode: false,
              align: 'left',
              itemGap: 24,//图例每项之间的间隔
              itemWidth: 7,
              itemHeight: 7,
              textStyle: {
                color: '#8B8788',
                fontSize: 11,
                padding: [0, 0, 0, 0]
              },
            },
            tooltip: {
              show: true,
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: '#FFCACA',
                  type: 'dash',
                },
                snap: false,
                label: {
                  formatter: '{value}'
                }
              },
            },
            grid: {
              top: '11%',
              left: '13%',
              right: '6%',
              bottom: '22%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: this.interactinfo.daykeylist,
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: '#969494',
                fontSize: 11
              },
              axisLine: {
                lineStyle: {
                  color: '#969494',
                },
              },
              boundaryGap: false,
            },
            yAxis: [
              {
                type: 'value',
                offset: '10',
                minInterval: 1,
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: '#969494'
                  },
                },
                axisTick: {
                  show: false,
                  inside: true,
                },
                axisLabel: {
                  fontSize: 11,
                  margin: 2,
                },
                splitLine: {
                  show:true,
                  lineStyle: {
                    color: '#f5f5f5',
                    height: 2
                  }
                },
              },
            ],
            dataZoom: [
              {
                type: 'inside',
                // start: this.state.timeMode == 2 ? 75 : 0,
                // end: this.state.timeMode == 2 ? 100 : 100,
                xAxisIndex: [0],
                filterMode: 'empty',
                handleSize: '10%',
                type: 'inside',
              }
            ],
            series: [
              {
                name: '总互动数',
                lineStyle: {
                  color: '#FC6C03',
                },
                data: this.interactinfo.interacnumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#FFD4CA' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
            ],
          })
        }
      })
    },
    getFansFn: function (type, isinit) {
      if (isinit != 1 && ((type == 0 && this.fansinfoShow) || (type == 1 && !this.fansinfoShow))) return
      if (type == 0) {
        this.fansinfoShow = true
      } else {
        this.fansinfoShow = false
      }
      let url = 'Wxmall/Community/getFanBaseData?type=' + type
      this.$customRequestAjax(url).then(res => {
        if (res.data.code == 200) {
          this.fansinfo = res.data.fansinfo
          echarts.init(document.getElementById('fansinfo')).setOption({
            color: ['#FC0324', '#0384FC', '#FCC349'],
            legend: {
              data: [{
                  name: '新增粉丝',
                  icon: 'circle',
                },
                {
                  name: '流失粉丝',
                  icon: 'circle',
                }],
              orient: 'horizontal',
              top: 'bottom',
              selectedMode: false,
              align: 'left',
              itemGap: 24,//图例每项之间的间隔
              itemWidth: 7,
              itemHeight: 7,
              textStyle: {
                color: '#8B8788',
                fontSize: 11,
                padding: [0, 0, 0, 0]
              },
            },
            tooltip: {
              show: true,
              trigger: 'axis',
              axisPointer: {
                type: 'line',
                lineStyle: {
                  color: '#FFCACA',
                  type: 'dash',
                },
                snap: false,
                label: {
                  formatter: '{value}'
                }
              },
            },
            grid: {
              top: '11%',
              left: '13%',
              right: '6%',
              bottom: '22%',
              containLabel: false,
            },
            xAxis: {
              type: 'category',
              data: this.fansinfo.daykeylist,
              axisTick: {
                show: false,
              },
              axisLabel: {
                color: '#969494',
                fontSize: 11
              },
              axisLine: {
                lineStyle: {
                  color: '#969494',
                },
              },
              boundaryGap: false,
            },
            yAxis: [
              {
                type: 'value',
                offset: '10',
                minInterval: 1,
                axisLine: {
                  show: false,
                  lineStyle: {
                    color: '#969494'
                  },
                },
                axisTick: {
                  show: false,
                  inside: true,
                },
                axisLabel: {
                  fontSize: 11,
                  margin: 2,
                },
                splitLine: {
                  show:true,
                  lineStyle: {
                    color: '#f5f5f5',
                    height: 2
                  }
                },
              },
            ],
            dataZoom: [
              {
                type: 'inside',
                // start: this.state.timeMode == 2 ? 75 : 0,
                // end: this.state.timeMode == 2 ? 100 : 100,
                xAxisIndex: [0],
                filterMode: 'empty',
                handleSize: '10%'
              }
            ],
            series: [
              {
                name: '新增粉丝',
                lineStyle: {
                  color: '#FC0324',
                },
                data: this.fansinfo.addfansnumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#FFD1D0' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              },
              {
                name: '流失粉丝',
                lineStyle: {
                  color: '#0384FC',
                },
                data: this.fansinfo.offfansnumlist,
                type: 'line',
                smooth: true,
                areaStyle: {
                  color: {
                    type: 'linear',
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [{
                      offset: 0, color: '#B9D2F3' // 0% 处的颜色
                    }, {
                      offset: 1, color: '#fff' // 100% 处的颜色
                    }],
                    globalCoord: false // 缺省为 false
                  }
                },
              }
            ],
          })
        }
      })
    },
    getLoyalFansFn: function (type) {
      var url = datacenterpath + 'Wxmall/Community/getFansOtherData', that = this
      if (Object.keys(this.loyalfansinitinfo).length > 0) {
        f()
      } else {
        this.$customRequestAjax(url).then(res => {
          if (res.data.code == 200) {
            this.loyalfansinitinfo = res.data.loyalfansinfo
            f()
            this.sexinfo = res.data.sexinfo
            this.ageinfo = res.data.ageinfo
            echarts.init(document.getElementById('ageinfo')).setOption({
              tooltip: {
                trigger: 'axis',
                axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                  type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
                }
              },
              calculable: true,
              grid: {
                top: '11%',
                left: '13%',
                right: '6%',
                bottom: '12%',
                containLabel: false,

              },
              xAxis: [{
                type: 'category',
                data: this.ageinfo.xaxis,
                axisTick: {
                  alignWithLabel: true
                },
                axisLine: {
                  lineStyle: {
                    color: '#F5F5F5'
                  }
                },
                axisLabel: {
                  color: '#969494',
                  fontSize: 11,
                  interval: 0
                },

              }],
              yAxis: [
                {
                  type: 'value',
                  offset: '10',
                  minInterval: 1,
                  axisLine: {
                    show: false,
                    lineStyle: {
                      color: '#F5F5F5'
                    }
                  },
                  axisLabel: {
                    color: '#969494',
                    fontSize: 11
                  },
                  splitLine: {
                    lineStyle: {
                      color: '#F5F5F5',
                      // type: 'dashed'
                    }
                  }
                }
              ],
              dataZoom: [
                {
                  id: 'dataZoomX',
                  // show: this.state.dataArr.value.length > 15 ? true : false,
                  // backgroundColor :'rgba(100,123,249,1)',
                  // dataBackground :{
                  //     areaStyle :{
                  //         color :'rgba(100,123,249,1)'
                  //     }
                  // },
                  // fillerColor :'rgba(100,123,249,0.4)',
                  // borderColor :'rgba(100,123,249,1)',
                  handleSize: '10%',
                  type: 'inside',
                  xAxisIndex: [0],
                  filterMode: 'empty',
                  // showDataShadow: false,
                  zoomLock: true,
                  //startValue:(parseInt(moment(new Date).format('H'))>=15?'15时':(moment(new Date).format('H时'))),
                  //endValue: moment(new Date).add(parseInt(moment(new Date).format('H')) <= 15 ? 8 : 23 - moment(new Date).format('H'), 'hours').format('H时'),
                  // startValue: this.state.startValue,
                  // endValue: this.state.endValue,
                }
              ],
              series: [
                {
                  type: 'bar',
                  barMaxWidth: 20,
                  data: this.ageinfo.yaxis
                },
              ],
              color: ['#FFCACA']
            })

          }
        })
      }
      function f () {
        if (type == 0) {
          that.loyalfansinfoShow = true
          that.loyalfansinfo = that.loyalfansinitinfo.sevendayslist
        } else {
          that.loyalfansinfoShow = false
          that.loyalfansinfo = that.loyalfansinitinfo.thirtydayslist
        }
      }
    },
    // 切换tab
    changeTab (index) {
      this.currentIndex = index
      this.$nextTick(function () {
        this.getData()
      })
    },
  }
}
</script>

<style scoped lang="scss">
  .comment {
    padding-left: 0.11rem;
    padding-top: 0.1rem;
  }
  .spacing {
    background: #ffffff;
    border-radius: 0.04rem;
    margin: 0.1rem 0.11rem;
    padding: 0.15rem 0.11rem;
    .title {
      p {
        font-weight: bold;
      }
    }
    .option {
      color: #EEEEEE;
      span {
        color: #8B8788;
        &.red {
          color: #FC0324;
        }
      }
    }
    .dataoverview {
      margin-top: 0.12rem;
      >div {
        padding: 0.08rem 0.12rem;
        background: #F5F5F5;
        border-radius: 0.1rem;
        margin-right: 0.1rem;
        position: relative;
        p {
          color: #333333;
          font-weight: bold;
        }
        .icon {
          position: absolute;
          right: 0.11rem;
          top: 0.1rem;
        }
      }
      >div:last-of-type {
        margin-right: 0;
      }
    }
    .postdata {
      img {
        width: 1.04rem;
        height: 1.04rem;
        object-fit: cover;
      }
      .postcontent {
        position: relative;
        height: 1.04rem;
        margin-left: 0.1rem;
        p {
          color: #292929;
        }
        span {
          position: absolute;
          bottom: 0;
          left: 0;
          display: block;
          color: #6D6D6D;
          white-space: nowrap;
        }
      }
    }
    .postdataoverview {
      >div {
        margin-bottom: 0.08rem;
        margin-right: 0;
        width: 47.74%;

      }
    }
    .fans {
      >div {
        background: transparent;
        text-align: center;
        padding: 0;
        margin-right: 0.2rem;
        width: 25%;
        img {
          width: 0.38rem;
          height: 0.38rem;
          border-radius: 50%;
          margin: 0 auto;
        }
        p {
          font-weight: normal;
          margin: 0.04rem 0 0.01rem;
        }
        span {
          color: #8B8788;
        }
      }
    }
    .gender {
      p {
        color: #222222;
        margin: 0.12rem 0 0.08rem;
      }
      .proportionexample {
        background: #eeeeee;
        >div {
          height: 0.2rem;
        }
        >div:first-of-type {
          width: 33%;
          background: #FC0324;
        }

        >div:nth-of-type(2) {
          width: 33%;
          background: #0384FC;
        }

        >div:last-of-type {
          width: 34%;
          background: #FFCD07;
        }
      }
      .proportion {
        color: #8B8788;
        margin-top: 0.06rem;
        >div {
          margin-right: 0.12rem;
        }
        >div:before {
          content: '';
          display: block;
          height: 0.07rem;
          width: 0.07rem;
          border-radius: 50%;
          margin-right: 0.06rem;
        }
        >div:first-of-type:before {
          background: #FC0324;
        }

        >div:nth-of-type(2):before {
          background: #0384FC;
        }

        >div:last-of-type:before {
          background: #FFCD07;
        }
      }
    }
    .nodata {
      background: #F5F5F5;
      text-align: center;
      padding: 0.2rem 0 0.14rem;
      border-radius: 0.1rem;
      margin-top: 0.08rem;
      img {
        width: 0.18rem;
        height: 0.2rem;
        margin: 0 auto 0.07rem;
      }
      p {
        color: #333333;
      }
    }
  }
  .tab {
    padding: 0.16rem 0.48rem 0.1rem;
    color: #292929;
    font-size: 0.14rem;
    background: #FFFFFF;
    .active {
      font-weight: bold;
      color: #FC0324;
      position: relative;
    }
    .active:after {
      position: absolute;
      left: 0;
      right: 0;
      content: '';
      display: block;
      width: 0.26rem;
      height: 0.03rem;
      background: #FC0324;
      margin: 0.05rem auto 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/community/dataCenter.vue